import type {MiraIconKey} from '../../icons/miraIcons';
import {buildPredictionTooltip} from '../../utils/buildPredictionTooltip';
import {MiraIcon} from '../MiraIcon/MiraIcon';
import {Table} from '../Table/Table';
import {Tooltip} from '../Tooltip/Tooltip';
import type {PartOperation, PartOperationVariant} from './CarPartModal.types';

const VARIANT_ICON: Record<PartOperationVariant, MiraIconKey> = {
  damage: 'mira/wrench',
  service: 'mira/screwdriver',
  suggestions: 'mira/lightbulb',
};

const STACK_CLASS = 'flex min-w-0 flex-col gap-1.5';

const DESCRIPTION_CLASS = 'text-sm leading-5 font-medium text-(--color-mira-blue-100)';

const FORECAST_ROW_CLASS = 'inline-flex flex-wrap items-center gap-2';

const PERCENTAGE_CLASS =
  'shrink-0 rounded-sm bg-(--color-mira-gray-100) px-1.5 py-0.5 text-xs leading-4 font-medium text-white tabular-nums';

const LABEL_CLASS = 'text-xs leading-4 text-(--color-text-secondary)';

export function OperationRow(props: PartOperation) {
  const showPercentage = props.percentage > 0;
  const tooltipContent = showPercentage
    ? buildPredictionTooltip(props.percentage, props.willNeed)
    : props.label;
  const percentageLabel = props.percentage.toString().concat('%');

  return (
    <Table.Row type={props.variant} icon={<MiraIcon name={VARIANT_ICON[props.variant]} />}>
      <Table.Cell isPrimary>
        <span className={STACK_CLASS}>
          <span className={DESCRIPTION_CLASS}>{props.description}</span>
          <Tooltip content={tooltipContent}>
            <span className={FORECAST_ROW_CLASS}>
              {showPercentage ? <span className={PERCENTAGE_CLASS}>{percentageLabel}</span> : null}
              <span className={LABEL_CLASS}>{props.label}</span>
            </span>
          </Tooltip>
        </span>
      </Table.Cell>
    </Table.Row>
  );
}
